import CitySEOHead from "@/components/feature/CitySEOHead";
import RosevilleHeroSection from "./components/HeroSection";
import RosevilleStickyNav from "./components/StickyNav";
import RosevilleProcessingTimeSection from "./components/ProcessingTimeSection";
import RosevilleServicesSection from "./components/ServicesSection";
import RosevilleLocalAreaSection from "./components/LocalAreaSection";
import RosevilleTravelTimingSection from "./components/TravelTimingSection";
import RosevilleDestinationsSection from "./components/DestinationsSection";
import RosevilleTestimonialsSection from "./components/TestimonialsSection";
import RosevilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import RosevilleComparisonSection from "./components/ComparisonSection";
import RosevilleMistakesSection from "./components/MistakesSection";
import RosevilleHowItWorksSection from "./components/HowItWorksSection";
import RosevilleFAQSection from "./components/FAQSection";
import { faqs } from "./components/FAQSection";
import RosevilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import RosevilleFinalCTA from "./components/FinalCTA";

export default function RosevilleMNPage() {
  return (
    <>
      <CitySEOHead
        city="Roseville"
        state="Minnesota"
        stateAbbr="MN"
        route="/roseville"
        title="Emergency Passport Roseville, MN — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Roseville, MN — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Rosedale area professionals, healthcare workers, Hmong & Vietnamese communities, and all of Ramsey County north metro."
        geoPlacename="Roseville, Minnesota"
        geoPosition="44.9961;-93.1566"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Minnesota"
        statePageRoute="/states/minnesota"
        keywords="expedited passport Roseville MN, emergency passport Roseville, passport renewal Ramsey County"
      />
      <div className="font-sans">
        <RosevilleHeroSection />
        <RosevilleStickyNav />
        <RosevilleProcessingTimeSection />
        <RosevilleServicesSection />
        <RosevilleLocalAreaSection />
        <RosevilleTravelTimingSection />
        <RosevilleDestinationsSection />
        <RosevilleTestimonialsSection />
        <RosevilleAcceptanceFacilitiesSection />
        <RosevilleComparisonSection />
        <RosevilleMistakesSection />
        <RosevilleHowItWorksSection />
        <RosevilleFAQSection />
        <RosevilleHelpfulResourcesSection />
        <RosevilleFinalCTA />
      </div>
    </>
  );
}